import React, { Fragment } from 'react';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';
import { FMessage } from '../../hoc/IntlComponents';
import Icon from '../Icon/Icon';
import { createMarkup } from '../../utils/utils';

export const StatusPopupInfo = ({ rowKey, statusId, statId, info }) => {
  const { p: phone, c: comment, s: schedule } = info;
  // if (!phone && !comment) {
  //   return null;
  // }
  const getFormattedComments = comm => {
    const comments = comm.split('\n');
    return comments.map((com, key) => <div key={key}>{com}</div>);
  };

  return (
    <span>
      <Icon type="info" />
      &nbsp;
      <UncontrolledPopover
        target={`status-info-${rowKey}-${statusId}-${statId}`}
        className="tooltip-status-info"
        placement="left"
        trigger="hover"
      >
        <PopoverBody>
          <Fragment>
            {schedule && (
              <div>
                <b>
                  <FMessage id="call.center.time" />
                </b>
                <div className="call-time" dangerouslySetInnerHTML={createMarkup(schedule)} />
              </div>
            )}
            {phone && (
              <div>
                <b>
                  <FMessage id="call.center.phone" />
                </b>
                <div>{phone}</div>
              </div>
            )}
            {comment && (
              <div>
                <b>
                  <FMessage id="call.center.comment" />
                </b>
                <div>{getFormattedComments(comment)}</div>
              </div>
            )}
          </Fragment>
        </PopoverBody>
      </UncontrolledPopover>
    </span>
  );
};

export default StatusPopupInfo;
